export enum AccountabilityStatusEnum {
  GENERATED,
  SUPERVISION,
  REVIEW,
  AUTHORIZED,
  CLOSED,
  CANCELLED,
  REJECTED,
  CLOSED_COLSAN,
  CLOSED_USER,
  PAID_COLSAN,
  PAID_USER
}
